import _ from 'lodash';
import createReactClass from 'create-react-class';
import d3 from 'd3';
import moment from 'moment';
import React from 'react';

export class AgentChartData {
  constructor({ days, values }) {
    _.assign(this, { days, values });
  }

  points() {
    return _.zipWith(this.days, this.values, (day, value) => {
      return { date: moment(day).toDate(), value };
    });
  }
}

import T from 'prop-types';
const AgentChart = createReactClass({
  propTypes: {
    data: T.instanceOf(AgentChartData).isRequired,
    height: T.number.isRequired,
    hPadding: T.number,
    vPadding: T.number,
    width: T.number.isRequired,

    // object that specifies which points to highlight
    highlight: T.shape({
      high: T.number.isRequired,
      low: T.number.isRequired,
    }),
  },

  statics: {
    POINT_RADIUS: 2,
  },

  /* renders */

  render() {
    let points = this.getPoints();
    let scales = this.getScales(points);

    return (
      <div className="agentChart">
        <svg width={this.props.width} height={this.props.height}>
          <path className="agentChart-sparkline" d={this.svgLine(points, scales)} />
          {this.renderSinglePoint(points, scales)}
          {this.renderHighlights(points, scales)}
        </svg>
      </div>
    );
  },

  renderSinglePoint(points, scales) {
    return points.nonZero.length !== 1 ? null : this.renderPoint('normal', points.nonZero[0], scales);
  },

  renderHighlights(points, scales) {
    if (!this.props.highlight) {
      return false;
    }

    const { high, low } = this.props.highlight;
    let highs = points.nonZero.filter(p => p.value >= high);
    let lows = points.nonZero.filter(p => p.value <= low);

    return (
      <g>
        {highs.map(p => this.renderPoint('high', p, scales))}
        {lows.map(p => this.renderPoint('low', p, scales))}
      </g>
    );
  },

  renderPoint(name, p, scale) {
    return (
      <circle
        className={`agentChart-sparkline-${name}`}
        key={p.date}
        cx={scale.x(p.date)}
        cy={scale.y(p.value)}
        r={AgentChart.POINT_RADIUS}
      />
    );
  },

  /* helpers */

  getPoints() {
    let points = this.props.data.points();
    return {
      all: points,
      nonZero: points.filter(p => p.value),
    };
  },

  getScales(points) {
    let vPadding = this.props.vPadding || 0;
    let xStart = vPadding;
    let xEnd = this.props.width - vPadding;

    let hPadding = this.props.hPadding || 0;
    let yStart = this.props.height - hPadding;
    let yEnd = hPadding;

    let scales = {};

    scales.x = d3.time
      .scale()
      .domain(d3.extent(points.all, p => p.date))
      .rangeRound([xStart, xEnd]);

    scales.y = d3.scale
      .linear()
      .domain(d3.extent(points.nonZero, p => p.value))
      .rangeRound([yStart, yEnd]);

    return scales;
  },

  svgLine(points, scales) {
    let svgLine = d3.svg
      .line()
      .x(p => scales.x(p.date))
      .y(p => scales.y(p.value));
    return svgLine(points.nonZero);
  },
});

export default AgentChart;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/reporting/report/lib/agent_chart.jsx